<template>
  <!--
      作者：gmshop
      时间：2019-10-25
      描述：订单列表
  -->
  <div class="user">
    <!--搜索表单-->
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
        <el-form-item label="订单号"><el-input size="small" v-model="searchForm.order_no" placeholder="请输入订单号"></el-input></el-form-item>
        <el-form-item label="预约手机号">
          <el-input size="small" style="width:100px" v-model="searchForm.subscribe_mobile" placeholder="预约手机号"></el-input>
        </el-form-item>
        <el-form-item label="会员手机号">
          <el-input size="small" style="width:100px" v-model="searchForm.mobile" placeholder="会员手机号"></el-input>
        </el-form-item>
        <el-form-item label="门店ID">
          <el-input size="small" style="width:100px" v-model="searchForm.store_id" placeholder="门店ID"></el-input>
        </el-form-item>
        <el-form-item label="下单时间">
          <div class="block">
            <span class="demonstration"></span>
            <el-date-picker
              size="small"
              v-model="searchForm.create_time"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            ></el-date-picker>
          </div>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
          <el-button size="small" type="primary" @click="onExport" v-auth="'/service/order/export'">导出</el-button>
          </el-form-item>
      </el-form>
    </div>
    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-tabs v-model="searchForm.status" @tab-click="handleClick">
          <el-tab-pane label="全部订单" name=""></el-tab-pane>
          <el-tab-pane label="待服务" name="1"></el-tab-pane>
          <el-tab-pane label="申请取消" name="3"></el-tab-pane>
          <el-tab-pane label="已取消" name="4"></el-tab-pane>
          <el-tab-pane label="已完成" name="2"></el-tab-pane>
        </el-tabs>
        <el-table size="small" :data="tableData.data" border style="width: 100%" v-loading="loading">
          <el-table-column prop="order_no" label="订单信息" width="400">
            <template slot-scope="scope">
              <div class="order-code">
                <span class="c_main">订单号：{{ scope.row.order_no }}</span>
                <span class="pl16">下单时间：{{ scope.row.create_time }}</span>
              </div>
              <div class="product-info">
                <div class="pic"><img v-img-url="scope.row.image.file_path" alt="" /></div>
                <div class="info">
                  <div class="name gray3 product-name">
                    <span>{{ scope.row.name }}</span>
                    <div style="margin-top:10px;" class="orange">￥ {{ scope.row.price }}</div>
                  </div>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="" label="用户">
            <template slot-scope="scope">
              <div v-if="scope.row.user && scope.row.user.nickName">{{ scope.row.user.nickName }}</div>
              <div class="gray9" v-if="scope.row.user && scope.row.user.user_id">ID：({{ scope.row.user.user_id }})</div>
              <div class="gray9">预约人：{{ scope.row.subscribe_name }}</div>
              <div class="gray9">预约手机号：{{ scope.row.subscribe_mobile }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="" label="店铺">
            <template slot-scope="scope">
              <div class="gray9">{{ scope.row.store.store_name }}</div>
            </template>
          </el-table-column>
          <el-table-column label="服务美容师">
            <template slot-scope="scope">
              <div class="gray9">{{ scope.row.clerk && scope.row.clerk.real_name}}</div>
            </template>
          </el-table-column>
          <el-table-column prop="status.text" label="订单状态"></el-table-column>
          <el-table-column prop="coupon_money" label="优惠金额"></el-table-column>
          <el-table-column prop="pay_price" label="实付金额"></el-table-column>
          <el-table-column prop="pay_type.text" label="支付方式">
            <template slot-scope="scope">
              <span class="gray9">{{ scope.row.pay_type.text }}</span>
            </template>
          </el-table-column>
          <el-table-column label="预约时间段">
            <template slot-scope="scope">
              <span class="gray9">{{ scope.row.subscribe_date + '【'+scope.row.subscribe_start_time+' - '+ scope.row.subscribe_end_time+'】' }}</span>
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="130">
            <template slot-scope="scope">
              <el-button v-if="scope.row.status.value == 1" @click="cancelClick(scope.row)" type="text" size="small" v-auth="'/service/order/orderCancel'">取消订单</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-sizes="[20, 50, 100, 200, 300, 500]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import ServiceApi from '@/api/service.js';
import qs from 'qs';
export default {
  data() {
    return {
      /*是否打开审核*/
      confirm_open: false,

      /*切换菜单*/
      activeName: 'all',
      /*是否加载完成*/
      loading: true,
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*横向表单数据模型*/
      searchForm: {
        subscribe_mobile: "",
        mobile: "",
        order_no: "",
        store_id: '',
        status: '',
        create_time: ''
      },
      /*时间*/
      create_time: '',
      data1: 'all',

      dataModel:{}
    };
  },
  created() {
    let tabs = this.$db.getRouteField(this, 'tabs');
    let page = this.$db.getRouteField(this, 'page');
    if (tabs) this.activeName = tabs;
    if (page) this.curPage = page;
    this.searchForm.store_id = this.$route.query.store_id
    this.searchForm.order_no = this.$route.query.order_no

    /*获取列表*/
    this.getData();

  },
  methods: {
    
    /*导出*/
    onExport() {
      let baseUrl = window.location.protocol + '//' + window.location.host;
    window.location.href = baseUrl + '/index.php/shop/plus.service.order/export?' + qs.stringify(this.searchForm);
    },
    /*选择第几页*/
    handleCurrentChange(val) {
      this.$db.setRoute(this, {'page': val});
      let self = this;
      self.curPage = val;
      self.getData();
    },
    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getData();
    },

    /*切换菜单*/
    handleClick(tab, event) {
      console.log(tab)
      console.log(tab.name)
      this.$db.setRoute(this, {'tabs': tab.name, 'page': 1});
      let self = this;
      self.curPage = 1;
      self.getData();
    },

    /*获取列表*/
    getData() {
      let self = this;
      let Params = this.searchForm;
      Params.page = self.curPage;
      Params.list_rows = self.pageSize;
      self.loading = true;
      ServiceApi.orderlist(Params, true)
        .then(res => {
          
          self.tableData.data = res.data.list.data;
          self.totalDataNumber = res.data.list.total;
          self.loading = false;
        })
        .catch(error => {});
    },

    /*取消订单*/
    cancelClick(row) {
      let self = this;
      self
        .$confirm('是否要取消订单, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          self.loading = true;
          ServiceApi.orderCancel(
            {
              id: row.id
            },
            true
          )
            .then(data => {
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.loading = false;
              self.getData();
            })
            .catch(error => {});
        })
        .catch(() => {});
    },
    

    /*搜索查询*/
    onSubmit() {
      this.$db.setRoute(this, {'page': 1});
      this.curPage = 1;
      this.tableData = [];
      this.getData();
    }
  }
};
</script>
<style lang="scss">
.product-info {
  padding: 10px 0;
  border-top: 1px solid #eeeeee;
}
.order-code .state-text {
  padding: 2px 4px;
  border-radius: 4px;
  background: #808080;
  color: #ffffff;
}
.order-code .state-text-red{ background: red;}
.table-wrap .product-info:first-of-type {
  border-top: none;
}
.table-wrap .el-table__body tbody .el-table__row:nth-child(odd) {
  background: #f5f7fa;
}
</style>



// WEBPACK FOOTER //
// src/views/service/order/index.vue